export const getGaSessionId = () => {
  if (typeof window == 'undefined') {
    return '';
  }

  const dataLayer = window?.dataLayer;

  if (!dataLayer) {
    console.warn('There is no dataLayer.');
    return '';
  }

  if (!dataLayer[0]) {
    console.warn('There is no dataLayer[0].');
    return '';
  }

  return String(dataLayer[0]['gtm.start']);
};
